export default __webpack_public_path__ + "static/media/South-Kerala.79c8079f.png";